import { z } from 'zod';

import { RMUpdateReviewSettingsSchema } from '@brightlocal/api-client';
import { RmReviewIdSchema, RmReviewStatusSchema } from '@brightlocal/shared';

import { STATUS_CHANGE_ORIGIN } from '../consts';
import type { ReviewStatusChange } from '../types';

/**
 * A status change as a mutation holds it: the review, the Update Review body, the status the review had and where the
 * customer picked the new one.
 */
const ReviewStatusChangeSchema = RMUpdateReviewSettingsSchema.extend({
  reviewId: RmReviewIdSchema,
  previousStatus: RmReviewStatusSchema,
  origin: z.nativeEnum(STATUS_CHANGE_ORIGIN)
}) satisfies z.ZodType<ReviewStatusChange>;

/**
 * Whether a value is a status change: TanStack Query hands mutation variables back as `unknown`.
 * @param variables - The variables a status change mutation was sent with.
 */
export const isReviewStatusChange = (variables: unknown): variables is ReviewStatusChange =>
  ReviewStatusChangeSchema.safeParse(variables).success;
